import { render } from "./ProjectBatteryAndBackupComponent.vue?vue&type=template&id=5d97243f&scoped=true&ts=true"
import script from "./ProjectBatteryAndBackupComponent.vue?vue&type=script&lang=ts"
export * from "./ProjectBatteryAndBackupComponent.vue?vue&type=script&lang=ts"

import "./ProjectBatteryAndBackupComponent.vue?vue&type=style&index=0&id=5d97243f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d97243f"]])

export default __exports__